// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.9 14L2.65 10.7C2.91 9.56 2.78 9.08 2.19 8.01C1.7 7.1 1.5 6.65 1.5 5.65C1.5 3.69 2.97 2.15 4.75 2.15C6.53 2.15 7.85 3.57 7.85 5.5V6.35C7.85 6.62 7.94 6.84 8.1 7.1L8.68 8.05C8.91 8.43 8.72 8.8 8.28 8.8H7.85V9.75C7.85 10.53 7.36 11 6.62 11H6.1V14',
  'M10.65 6.2C11.93 7.48 11.93 9.52 10.65 10.8',
  'M12.8 3.95C15.3 6.45 15.3 10.55 12.8 13.05',
];
